export default __webpack_public_path__ + "static/media/cv-rect.6f162424.jpg";